const PhoneWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="p-[5px] h-full w-full flex items-center justify-center">
      <div className="relative h-full aspect-[380/780] rounded-[40px] shadow-[0px_0px_0px_4px_#272b30,0px_0px_0px_6px_#33383f,0px_0px_0px_12px_black] after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:z-[4] after:bottom-[1%] after:w-[38%] after:h-[0.5%] after:bg-[#fcfcfc] after:rounded-[10px]">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60%] bg-[#1a1d1f] rounded-b-[20px] z-[4] flex items-center justify-center gap-5 px-5 pt-[3px] pb-2">
          <span className="h-2 w-[30%] bg-black rounded-[8px] shadow-[inset_0px_-3px_3px_0px_rgba(239,239,239,0.25)]" />
          <span className="relative w-3 h-3 bg-[#6f767e] rounded-full shadow-[inset_0px_-3px_2px_0px_rgba(255,255,255,0.2)] after:content-[''] after:absolute after:bg-[#2d4d76] after:w-1.5 after:h-1.5 after:top-[3px] after:left-[3px] after:block after:rounded-full after:shadow-[inset_0px_-2px_2px_rgba(0,0,0,0.5)]" />
        </div>
        <div className="h-full w-full bg-[#fcfcfc] overflow-hidden rounded-[40px] relative z-[1]">
          {children}
        </div>
      </div>
    </div>
  )
}

export default PhoneWrapper
